import { PaginationContextProvider } from 'utils/contexts/pagination';
import { SortingContextProvider } from 'utils/contexts/sorting';

import { SnippetIndexPage } from './components/SnippetIndexPage';
import { defaultSortField } from './constants';
import { SnippetFiltersContextProvider } from './context/SnippetFiltersContextProvider';
import { SnippetQueryContextProvider } from './context/SnippetQueryContextProvider';

export const SnippetContext = () => (
  <SortingContextProvider defaultSortField={defaultSortField}>
    <PaginationContextProvider>
      <SnippetFiltersContextProvider>
        <SnippetQueryContextProvider>
          <SnippetIndexPage />
        </SnippetQueryContextProvider>
      </SnippetFiltersContextProvider>
    </PaginationContextProvider>
  </SortingContextProvider>
);
